class SessionSequenceProvider {
	#sessionSequence: number;

	constructor() {
		this.#sessionSequence = 0;
	}

	incrementAndGetSequence() {
		this.#sessionSequence += 1;
		return this.#sessionSequence;
	}
}

const sequenceInstance = new SessionSequenceProvider();

export default sequenceInstance;
